import { S3EventForm } from "./form";

export function S3EventsNew() {
  return <S3EventForm isNew />;
}
